(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discover-fabrics"] && !window.DesignMode) return;
  try {
    
const errorMessage = $('.mm').text();
function disabledProduct(){
  var disabledId = [];
  $('.sample-product').each(function () {
    disabledId.push($(this).children('a').attr('data-delet'))
  })
  $('.addSample').each(function() {
    const productId = $(this).attr('data-product-id');
    if (disabledId.includes(productId)) {
      $(this).addClass('disabled');
    }else{
      $(this).removeClass('disabled');
    }
  });
}
 $(document).ready(function () {

  function textChangeCallback(mutationsList, observer) {
    disabledProduct();
  }
  const targetElement = document.getElementById('checkChange'); 
  const observer = new MutationObserver(textChangeCallback);
  const config = { childList: true, subtree: true, characterData: true };
  observer.observe(targetElement, config);
 
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (cart) {
        if (cart.item_count > 0) {
          var sampleProductsContainer;

          $.each(cart.items, function (index, item) {

            if (item.image.includes('Fabric') && item.final_price == 0) {

              productExist.push(item);
              var itemCount = parseInt(productExist.length);
              $(".selected-count").html("You have selected " + itemCount + " out of 6 samples");
              
              var sampleProductLink = $('<a class="basket-product"></a>').attr('href', "#" ).attr('data-delet', item.variant_id); //item.url
              var sampleProductImage = $('<img>').attr('src', item.image);

              sampleProductLink.append(sampleProductImage);
              sampleProductsContainer = sampleProductLink;
              var updated = false;
              $('.sample-product').each(function () {
                if (!updated && $(this).children('span').length > 0) {
                  $(this).html(sampleProductsContainer);
                  updated = true;   
                }
              });
            }
            
          });
          
        }
      }
    });

    setTimeout(function() {
      disabledProduct()
      $('.basket-product').click('click', function (event) {
        event.preventDefault(); 
        var takeMe = $(this);
        var variantId = $(this).attr('data-delet');
        $('<div class="sample-product"></div>');
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            quantity: 0, 
            id: variantId
          },
          dataType: 'json',
          success: function (cart) {

          if (productExist.length > 0) {
            productExist.shift();
          }

          takeMe.parent().append('<span> </span>');
          takeMe.remove()
          itemCount = (free_samples.items.length || 0) + (productExist.length || 0);
          $(".selected-count").html("You have selected " + itemCount + " out of 6 samples");

          },
          error: function () {
            console.error('Failed to remove the product from the cart.');
          }
        });
      });
    }, 1000);
  });
  $('.addSample').on('click', function () {
    itemCount = (free_samples.items.length || 0) + (productExist.length || 0); 
    if(itemCount >= 6){
      $('.error-msg').html(`<div class="err">${errorMessage}</div>`);
      return;
    }
    
    const productID = $(this).data('product-id');
    const image = "https://" + window.Shopify.shop + "/cdn/shop/" + $(this).data('image');

    if (productID === undefined) {  
      console.log("OUT OF STOCK");
      return;  
    }

    var cartData = {
      "id": productID,
      "quantity": 1
    };  
  
    free_samples.items.push(cartData)  

    totalCount = parseInt(totalCount)+1;
    itemCount = (free_samples.items.length || 0) + (productExist.length || 0); 
    $(".selected-count").html("You have selected " + itemCount + " out of 6 samples");

    var updated = false;

    $('.sample-product').each(function () {  
      if(itemCount > 6){
      $('.error-msg').html(`<div class="err">${errorMessage}</div>`);
        return 0;
      }  
      if (!updated && $(this).children('span').length > 0) {
        $(this).html(`<a onclick="
            $(this).parent().append('<span> </span>'); 
            $(this).remove();
            if (itemCount) {
              itemCount = itemCount - 1;
            }
            if (free_samples.items.length > 0){
              free_samples.items.shift();
              $('.selected-count').html('You have selected ' + itemCount + ' out of 6 samples');
            }          " 
        data-delet="${productID}"><img width="100px" height="100px" src="${image}"></a>`);
        updated = true;
      }
    });
    disabledProduct()   
  });  

  $('.sample-checkout-btn').on('click', function () {
    const sendData = free_samples

    $.post(window.Shopify.routes.root + 'cart/add.js', sendData);

    // Redirect to the cart page 
    setTimeout(function() { 
      window.location.href = "/cart"; 
    },2000)
  });

  $('.readless').on( 'click', function () {
      var more = $(this).siblings('.more');
      
      if ($(this).text() === "Show More") {
        $(this).text("Show Less");
        more.slideDown();
      } else { 
        $(this).text("Show More");
        more.slideUp(); 
      }
    }); 
    if(window.innerWidth <= 1124){

    window.addEventListener('scroll', function() {
      var addON = 200; 
     
      var collectionsList = document.querySelector('.my_container');
      var dd = document.querySelector('.dd');

      if (!collectionsList) {
        // Handle the case when '.my_container' is not found
        return;
      }



      var collectionsListBottom = collectionsList.offsetTop + collectionsList.offsetHeight;
      var scrollTop = window.scrollY;
      var windowHeight = window.innerHeight;

      if (collectionsListBottom + addON > scrollTop + windowHeight) {
        dd.classList.remove('fade-out');
      } else { 
        dd.classList.add('fade-out');
      }
    }); 
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-popup"] && !window.DesignMode) return;
  try {
    

function shouldDisplayPopup() {
    if (!sessionStorage.getItem('popupShown')) {
        showElements();
        document.body.style.overflow = 'hidden';
        sessionStorage.setItem('popupShown', 'true');
    }
}

function getUserLocation() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "https://ipinfo.io",
            dataType: "jsonp",
            success: function(response) {
                resolve(response);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }
        });
    });
}

getUserLocation()
    .then(response => {
        if(response.country == "US") {
            shouldDisplayPopup();
        }else{
            return;
        }
    })
    .catch(error => {
        console.error("Error fetching user location:", error);
    });

    function showElements() {
    var laoverlocationElements = document.querySelectorAll('.laoverlocation');
    laoverlocationElements.forEach(function(element) {
        element.style.display = 'block';
    });

    var sectionpopupElements = document.querySelectorAll('.sectionpopup');
    sectionpopupElements.forEach(function(element) {
        element.style.display = 'block';
    });
}
document.addEventListener("DOMContentLoaded", () => {
    $(".laoverlocation, .closeNutton svg, .transparentbutton").on('click', function() {
        $(".laoverlocation, .sectionpopup").fadeOut();
        document.body.style.overflow = 'auto';
    });
})
 

  } catch(e) { console.error(e); }
})();
})();
